<template>
  <!-- باکس‌های انتخابی روشن/خاموش؛ تک‌انتخابی یا چندانتخابی -->
  <div
    class="option-cards"
    :class="{ 'option-cards--compact': compact }"
    :role="multiple ? 'group' : 'radiogroup'"
  >
    <button
      v-for="option in options"
      :key="option.value"
      type="button"
      class="option-card"
      :class="{ 'option-card--active': isActive(option.value) }"
      :role="multiple ? 'checkbox' : 'radio'"
      :aria-checked="isActive(option.value) ? 'true' : 'false'"
      @click="toggle(option.value)"
    >
      <span v-if="option.icon" class="option-card__icon">
        <feather-icon :icon="option.icon" :size="compact ? '16' : '20'" />
      </span>
      <span class="option-card__body">
        <span class="option-card__title">{{ option.text }}</span>
        <span v-if="option.description && !compact" class="option-card__desc">
          {{ option.description }}
        </span>
      </span>
      <span class="option-card__check" aria-hidden="true">
        <feather-icon v-if="isActive(option.value)" icon="CheckIcon" size="12" />
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    // [{ value, text, description?, icon? }]
    options: {
      type: Array,
      required: true,
    },
    value: {
      type: [Array, Number, String, Boolean],
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    isActive(optionValue) {
      if (this.multiple) {
        return (this.value || []).includes(optionValue);
      }
      return this.value === optionValue;
    },
    toggle(optionValue) {
      if (!this.multiple) {
        this.$emit("input", optionValue);
        return;
      }
      const current = this.value || [];
      const next = current.includes(optionValue)
        ? current.filter((item) => item !== optionValue)
        : [...current, optionValue];
      this.$emit("input", next);
    },
  },
};
</script>

<style scoped>
.option-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 0.75rem;
}

.option-cards--compact {
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 0.5rem;
}

.option-card {
  position: relative;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  width: 100%;
  padding: 0.85rem 1rem;
  border: 1px solid #d8d6de;
  border-radius: 0.5rem;
  background-color: #ffffff;
  color: #5e5873;
  /* postcss-rtl این را در RTL به راست برمی‌گرداند */
  text-align: left;
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease,
    box-shadow 0.15s ease;
}

.option-cards--compact .option-card {
  padding: 0.5rem 0.75rem;
  gap: 0.5rem;
}

.option-card:hover {
  border-color: #7367f0;
}

.option-card:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(115, 103, 240, 0.25);
}

.option-card--active {
  border-color: #7367f0;
  background-color: rgba(115, 103, 240, 0.08);
  color: #7367f0;
}

.option-card__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 2.25rem;
  height: 2.25rem;
  border-radius: 0.4rem;
  background-color: #f3f2f7;
  color: #6e6b7b;
}

.option-cards--compact .option-card__icon {
  width: 1.75rem;
  height: 1.75rem;
}

.option-card--active .option-card__icon {
  background-color: #7367f0;
  color: #ffffff;
}

.option-card__body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.option-card__title {
  font-weight: 600;
  font-size: 0.95rem;
}

.option-cards--compact .option-card__title {
  font-size: 0.875rem;
}

.option-card__desc {
  margin-top: 0.15rem;
  font-size: 0.75rem;
  color: #b9b9c3;
}

.option-card__check {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1.1rem;
  height: 1.1rem;
  border: 1.5px solid #d8d6de;
  border-radius: 0.3rem;
  color: #ffffff;
}

.option-card--active .option-card__check {
  border-color: #7367f0;
  background-color: #7367f0;
}

/* تم تاریک پنل */
.dark-layout .option-card {
  border-color: #404656;
  background-color: #283046;
  color: #d0d2d6;
}

.dark-layout .option-card__icon {
  background-color: #343d55;
  color: #d0d2d6;
}

.dark-layout .option-card--active {
  border-color: #7367f0;
  background-color: rgba(115, 103, 240, 0.15);
  color: #ffffff;
}

.dark-layout .option-card--active .option-card__icon {
  background-color: #7367f0;
}

@media (prefers-reduced-motion: reduce) {
  .option-card {
    transition: none;
  }
}
</style>
